import { MutationTree } from 'vuex'
import { Things } from './types'
import { Vehicle, Flex } from '@/helpers/objects'

export const mutations: MutationTree<Things> = {
  setThings(state, dataThing) {
    let newThing
    switch (dataThing.type) {
      case 'vehicle':
        newThing = new Vehicle({
          id: dataThing.id,
          uriId: dataThing.uriId,
          name: dataThing.name,
          aliasesQuantity: dataThing.aliasesQuantity,
          isAlias: dataThing.isAlias,
          type: dataThing.type,
          subType: dataThing.subType,
          tags: dataThing. tags,
          domain: dataThing.domain,
          lastReport: dataThing.lastReport,
          agents: dataThing.agents,
          make: dataThing.make,
          model: dataThing.model,
          year: dataThing.year,
          color: dataThing.color,
          chasisNumber: dataThing.chasisNumber,
          engineNumber: dataThing.engineNumber,
          serviceName: dataThing.serviceName,
          serviceStatus: dataThing.serviceStatus,
          created: dataThing.created,
          serviceList: dataThing.serviceList,
          mileage_reading: dataThing.mileage_reading,
          usage_reading: dataThing.usage_reading,
          additionalInfo: dataThing.additionalInfo,
          photo: dataThing.photo
        })

        break
      case 'flex':
        newThing = new Flex({
          id: dataThing.id,
          uriId: dataThing.uriId,
          name: dataThing.name,
          aliasesQuantity: dataThing.aliasesQuantity,
          isAlias: dataThing.isAlias,
          type: dataThing.type,
          subType: dataThing.subType,
          tags: dataThing.tags,
          domain: dataThing.domain,
          lastReport: dataThing.lastReport,
          agents: dataThing.agents,
          serviceName: dataThing.serviceName,
          serviceStatus: dataThing.serviceStatus,
          created: dataThing.created,
          serviceList: dataThing.serviceList,
          mileage_reading: dataThing.mileage_reading,
          usage_reading: dataThing.usage_reading,
          additionalInfo: dataThing.additionalInfo,
          photo: dataThing.photo
        })
        break

      default:
        break
    }
    state.things.push(newThing)
  },
  cleanThingsState(state) {
    state.things.splice(0)
  },
  resetFilterThingsState(state) {
    state.filterThings = state.things
  },
  setResponseError(state, payload) {
    state.responseError = payload
  },
  setResponseMessage(state, message) {
    state.responseMessage = message
  },
  setCurrentThing(state, dataThing) {
    let newThing
    switch (dataThing.type) {
      case 'vehicle':
        newThing = new Vehicle({
          id: dataThing.id,
          uriId: dataThing.uriId,
          name: dataThing.name,
          aliasesQuantity: dataThing.aliasesQuantity,
          isAlias: dataThing.isAlias,
          type: dataThing.type,
          subType: dataThing.subType,
          tags: dataThing.tags,
          domain: dataThing.domain,
          lastReport: dataThing.lastReport,
          agents: dataThing.agents,
          make: dataThing.make,
          model: dataThing.model,
          year: dataThing.year,
          color: dataThing.color,
          chasisNumber: dataThing.chasisNumber,
          engineNumber: dataThing.engineNumber,
          serviceName: dataThing.serviceName,
          serviceStatus: dataThing.serviceStatus,
          created: dataThing.created,
          serviceList: dataThing.serviceList,
          mileage_reading: dataThing.mileage_reading,
          usage_reading: dataThing.usage_reading,
          additionalInfo: dataThing.additionalInfo,
          photo: dataThing.photo
        })

        break
      case 'flex':
        newThing = new Flex({
          id: dataThing.id,
          uriId: dataThing.uriId,
          name: dataThing.name,
          aliasesQuantity: dataThing.aliasesQuantity,
          isAlias: dataThing.isAlias,
          type: dataThing.type,
          subType: dataThing.subType,
          tags: dataThing.tags,
          domain: dataThing.domain,
          lastReport: dataThing.lastReport,
          agents: dataThing.agents,
          serviceName: dataThing.serviceName,
          serviceStatus: dataThing.serviceStatus,
          created: dataThing.created,
          serviceList: dataThing.serviceList,
          mileage_reading: dataThing.mileage_reading,
          usage_reading: dataThing.usage_reading,
          additionalInfo: dataThing.additionalInfo,
          photo: dataThing.photo
        })
        break

      default:
        break
    }
    state.currentThing = newThing
  },
  resetCurrentThing(state) {
    state.currentThing = {}
  },
  updateThingName(state, payload) {
    for (let i = 0; i < state.things.length; i++) {
      if (state.things[i].uriId === payload.uriId) {
        state.things[i].name = payload.label
        state.things[i].mileage_reading = payload.mileageReading
        state.things[i].usage_reading = Math.round(payload.usageReading / 3600)
        state.things[i].additionalInfo = payload.userInfo
        break
      }
    }
  },
  setFilterThingsByString(state, { filterTings }) {
    state.filterThings = filterTings
  },
  setContactEmergencyFromPerson(state, contactEmergencyFromPerson) {
    state.contactEmergencyFromPerson = contactEmergencyFromPerson
  }
}
